import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '../stylus/main.styl';

Vue.use(Vuetify, {
  theme: {
    primary: '#321A32',
    secondary: '#5C415B',
    accent: '#88C83D',
    error: '#ef1515',
    info: '#2196F3',
    success: '#88C83D',
    warning: '#FFC600',
  },
  customProperties: true,
  iconfont: 'fa',
});
